export class mdlGetEditProposalDetailsReq{
    public RegNo: string;
    public ProposalNo: string;
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/mdlGetEditProposalDetailsReq.ts